var ValueJS = ValueJS || {};

ValueJS.BootstrapTooltips = function() {

    var _selector = '[data-bs-toggle="tooltip"]';
    var _tooltips = [];
    var _initialized = false;

    var _init = function() {
        // initiate tooltips
        if (!_initialized) {
            var tooltipTriggerList = [].slice.call(document.querySelectorAll(_selector))
            var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
                _tooltips.push(new bootstrap.Tooltip(tooltipTriggerEl));
            })
            _initialized = true;
        }
    }

    var _domUpdate = function() {
        _tooltips.forEach(function(tooltip) {
            tooltip.dispose();
        });
        _tooltips = [];
        _initialized = false;
        _init();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    // ValueJS.BootstrapTooltips.init();
    // ValueJS.BootstrapTooltips.domUpdate();
});
